import { iots } from '@code-expert/prelude';

export const UseCase = iots.literal('restore');

export type UseCase = iots.TypeOf<typeof UseCase>;
